import { useCallback } from "react";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import {
    APPEARANCE_COOKIE_MAX_AGE_DAYS,
    APPEARANCE_COOKIE_NAME,
    Appearance,
    AppearancePreference,
} from "../../../../shared/appearance";
import { RootState } from "../../../../models";
import { setAppearance } from "../state/configActions";
import { getAppearance, getAppearancePreference } from "../state/selectors";

interface UseAppearance {
    /** What the user chose. "system" means follow the OS setting. */
    preference: AppearancePreference;
    /** What is actually rendered. */
    resolved: Appearance;
    /** "light" and "dark" are stored as an override, "system" removes the override. */
    setPreference: (preference: AppearancePreference) => void;
}

export const useAppearance = (): UseAppearance => {
    const dispatch = useDispatch();
    const preference = useSelector((state: RootState) => getAppearancePreference(state));
    const resolved = useSelector((state: RootState) => getAppearance(state));

    const setPreference = useCallback(
        (next: AppearancePreference) => {
            if (next === "system") {
                Cookies.remove(APPEARANCE_COOKIE_NAME, { path: "/" });
            } else {
                Cookies.set(APPEARANCE_COOKIE_NAME, next, {
                    expires: APPEARANCE_COOKIE_MAX_AGE_DAYS,
                    path: "/",
                    sameSite: "lax",
                });
            }
            dispatch(setAppearance(next));
        },
        [dispatch],
    );

    return { preference, resolved, setPreference };
};
